// src/services/emailService.js
import { emailSetupAPI, emailTemplatesAPI } from './api';

export const emailSetupService = {
  getEmailSetup: async () => {
    try {
      const response = await emailSetupAPI.getEmailSetup();
      
      // Handle the response format from your backend
      if (response.data && response.data.exists === false) {
        return { exists: false, message: response.data.message };
      }
      
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching email setup:', error);
      
      if (error.response?.status === 404) {
        return { exists: false, message: 'No email setup configured' };
      }
      
      return { 
        exists: false, 
        message: error.response?.data?.message || 'Failed to load email setup',
        error: true 
      };
    }
  },

  saveEmailSetup: async (setupData) => {
    try {
      const response = await emailSetupAPI.saveEmailSetup(setupData);
      return response.data;
    } catch (error) {
      console.error('❌ Error saving email setup:', error);
      console.error('❌ Error details:', error.response?.data);
      throw new Error(error.response?.data?.message || error.response?.data || 'Failed to save email setup');
    }
  },

  testEmailSetup: async (testData) => {
    try {
      const response = await emailSetupAPI.testEmailSetup(testData);
      return response.data;
    } catch (error) {
      console.error('❌ Error testing email setup:', error);
      throw new Error(error.response?.data?.message || 'Failed to test email connection');
    }
  },
  // New method to get all setups
  getAllEmailSetups: async () => {
    try {
      const response = await emailSetupAPI.getAllEmailSetups();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching all email setups:', error);
      throw new Error(error.response?.data?.message || 'Failed to load email setups');
    }
  }
};

export const emailTemplateService = {
  getTemplates: async () => {
    try {
      const response = await emailTemplatesAPI.getTemplates();
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching email templates:', error);
      throw new Error(error.response?.data?.message || 'Failed to load email templates');
    }
  },

  getTemplate: async (id) => {
    try {
      const response = await emailTemplatesAPI.getTemplate(id);
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching email template:', error);
      throw new Error(error.response?.data?.message || 'Failed to load email template');
    }
  },

  createTemplate: async (template) => {
    try {
      const response = await emailTemplatesAPI.createTemplate(template);
      return response.data;
    } catch (error) {
      console.error('❌ Error creating email template:', error);
      throw new Error(error.response?.data?.message || 'Failed to create email template');
    }
  },

  updateTemplate: async (id, template) => {
    try {
      const response = await emailTemplatesAPI.updateTemplate(id, template);
      return response.data;
    } catch (error) {
      console.error('❌ Error updating email template:', error);
      throw new Error(error.response?.data?.message || 'Failed to update email template');
    }
  },

  deleteTemplate: async (id) => {
    try {
      const response = await emailTemplatesAPI.deleteTemplate(id);
      return response.data;
    } catch (error) {
      console.error('❌ Error deleting email template:', error);
      throw new Error(error.response?.data?.message || 'Failed to delete email template');
    }
  }
};

